import Image from "components/image/image.component";
import Selector from "components/selector/selector.component";
import { Fragment, useContext, useEffect, useState } from "react";
import { BsPersonFill } from "react-icons/bs";
import { ClientsContext } from "src/contexts/clients.context";

import useTranslate from "src/hooks/use-translate";
import { getItemWhere } from "utils/array.utils";
import { POSITIONS } from "utils/lists.utils";

import "./people-sub-category.style.scss";

const sortEmployeeList = (list) => {
	const admins = list.filter((person) => person.userType === 0);
	const members = list.filter((person) => person.userType === 1);
	return [...admins, ...members];
};

const PeopleSubTab = ({ id }) => {
	const { clients, updateEmployees } = useContext(ClientsContext);
	const t = useTranslate("PeopleSubTab");

	const { companyType } = getItemWhere(clients, "id", id).company;

	const isPersonalAccount = companyType === 0;

	let data, color;
	if (isPersonalAccount) {
		data = getItemWhere(clients, "id", id).company;
		({ color } = data);
	} else if (companyType === 1) {
		data = getItemWhere(clients, "id", id).company.employees;
		({ color } = getItemWhere(clients, "id", id).company.company);
	}

	const people = isPersonalAccount ? [data] : sortEmployeeList(data);
	// const [people, setPeople] = useState(isPersonalAccount ? [data] : sortEmployeeList(data));

	const handleRemove = (idx) => {
		if (idx === 0 && people[1].userType !== 0) {
			alert("There should be at least one admin left!");
			return;
		}

		const newList = [...people];
		newList.splice(idx, 1);
		updateEmployees(id, newList);
	};

	const handleChangeType = (idx, newType) => {
		if (newType === 1 && people[1].userType !== 0) {
			alert("There should be at least one admin left!");
			return;
		}

		const newList = [...people];
		newList[idx].userType = newType;
		updateEmployees(id, newList);
	};
	return (
		<div className="people-sub-category-container padding-m--left">
			<p className="w600 size400 with-line">{t("People")}</p>
			{people.map((person, index) => {
				const { name, surname, jobTitle, userType } = person;

				return (
					<div key={index} className="person padding-s--bottom padding-m--top">
						<div
							className="img"
							style={{
								borderColor: color,
								borderWidth: "0.25rem",
							}}
						>
							<Image name={name + " " + surname} color={color} />
						</div>
						<p className="w600 size400">{name + " " + surname}</p>
						<div className="flex gap-s">
							<BsPersonFill />
							<span>{t(jobTitle)}</span>
						</div>
						{isPersonalAccount && (
							<div className="border text-center smooth-corners padding-xs--block">
								{t("Administrator")}
							</div>
						)}
						{!isPersonalAccount && (
							<Fragment>
								<Selector
									onSelected={(value) => {
										handleChangeType(index, POSITIONS.indexOf(value));
									}}
									data={POSITIONS}
									selected={POSITIONS[userType]}
								/>
								<button onClick={() => handleRemove(index)} className="size40 w400">
									{t("Remove")}
								</button>
							</Fragment>
						)}
					</div>
				);
			})}
		</div>
	);
};

export default PeopleSubTab;
